<div class="block-screen" [style.zIndex]="zIndex" *ngIf="visible" (click)="blockScreenClicked.emit()"></div>
